
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import Select from 'react-select';
import hotelcss from './css/hotelhotellist.module.css';
import { retrieveCheckinData, getView, gethotelcleaners, getMyLinkedhotels, getemployees } from '../dbconnector/connector'
import { getCookie } from '../dbconnector/checktoken'
import ActivityreportDetails from '../customNodes/ActivityreportDetails';
import 'react-calendar/dist/Calendar.css';
import { useState } from 'react';
import EmployeeSelection from '../customNodes/EmployeeSelection';
import HotelSelection from '../customNodes/HotelSelection';
import Button from 'react-bootstrap/Button';
import { setErrorMessage, clearMessage, setMessage } from '../tools/errorhandling';

//import hotelcss from './css/hotelhotellist.module.css';




const ActivityReport = (props) => {
    const [linkedcleaners, setlinkedcleaners] = useState({});
    const [getactiveEmployee, setGetactiveEmployees] = useState(true);
    const [selectedhotel, setSelectedhotel] = useState(null);
    const [selectedreportdata, setSelectedReportdata] = useState({});
    const [lastselectedrecord, setLastSelectedRecord] = useState(null);
    const navigate = useNavigate();
    const t = props.translation
    const [optionArray, setoptionArray] = useState([]);
    const [selectedCleaner, setselectedCleaner] = useState(null);
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);

    const filterlist = async (navigate, t) => {
        try {
            document.getElementById("list").innerHTML = "";
            let fields;
            let values;
            const year = document.getElementById("yearselection").value;
            const month = Number(document.getElementById("monthselection").value);
            const employeeid = selectedCleaner
            if (year && employeeid !== null && month > 0) {
                //console.log("a")
                fields = '["year","Month","assignee_Id"]';
                values = `[${year},${month},${employeeid}]`;
            }
            if (year && employeeid !== null && month === 0) {
                //console.log("b")
                fields = '["year","assignee_Id"]';
                values = `[${year},${employeeid}]`;
            }
            if (year && employeeid === null && month > 0) {
                //console.log("c")
                fields = '["year","Month"]';
                values = `[${year},${month}]`;
            }
            if (year && employeeid === null && month === 0) {
                //console.log("d")
                fields = '["year"]';
                values = `[${year}]`;
            }
            if (!year && employeeid !== null && month === 0) {
                //console.log("e")
                fields = '["assignee_Id"]';
                values = `[${employeeid}]`;
            }
            if (!year && employeeid === null && month > 0) {
                //console.log("f")
                fields = '["Month"]';
                values = `[${month}]`;
            }
            if (!year && employeeid !== null && month > 0) {
                //console.log("g")
                fields = '["assignee_Id","Month"]';
                values = `[${employeeid},${month}]`;
            }


            if (!year && employeeid === null && month === 0) {
                //console.log("h")
                fields = null;
                values = null;
                setMessage("Sorry, deze opdracht kan ik niet uitvoeren. Minstens één van de filtercriteria moet ingevuld zijn")
            } else {
                //TODO: getview cannot handle null objects
                getView("employee_activityreport", fields, values).then(res => {
                    if (res.status === 200) {
                        res.json().then(body => {
                            if (body.length > 0) {
                                clearMessage();
                                //console.log("result: ", body)
                                createlist(body)
                            }
                            else { setMessage("Er zijn geen activiteiten gevonden met deze zoekgegevens") }
                        })
                    } else {
                        setErrorMessage(res.statusText)
                    }

                })
            }
        } catch (e) { setErrorMessage(t("error_filterfailed")) }
    }
    const createyearselect = () => {
        //yearselection
        let yearselect = document.getElementById("yearselection")
        yearselect.innerHTML = "";

        const option = document.createElement("option")
        option.innerText = "2025"
        option.value = "2025"
        yearselect.appendChild(option)

        const option2 = document.createElement("option")
        option2.innerText = "2026"
        option2.value = "2026"
        yearselect.appendChild(option2)

    }

    const createlist = (list, t) => {
        //createheaders()

        let divlist = document.getElementById("list")
        divlist.innerHTML = "";
        //create a list item for every element in the received array
        list.forEach((element, index) => {
            //console.log(element)
            //create wrapper employeediv
            const employediv = document.createElement("div")



            const EMP_ID_div = document.createElement("p")
            EMP_ID_div.innerText = element.nr_wkn
            EMP_ID_div.className = "gridrowheight"
            employediv.appendChild(EMP_ID_div)

            const name = document.createElement("p")
            employediv.appendChild(name)
            name.className = "gridrowheight"
            name.innerText = element.achternaam + ", " + element.voornaam




            const month = document.createElement("p");
            month.innerText = element.Month
            month.className = "gridrowheight"
            employediv.appendChild(month);

            const work = document.createElement("p");
            work.innerText = element.gewerkte_cleaning_uren
            work.className = "gridrowheight"
            employediv.appendChild(work);

            const ziek = document.createElement("p");
            ziek.innerText = element.ziektedagen
            ziek.className = "gridrowheight"
            employediv.appendChild(ziek);

            const vrij = document.createElement("p");
            vrij.innerText = element.vrijedagen
            vrij.className = "gridrowheight"
            employediv.appendChild(vrij);
            //holidays
            const vakantie = document.createElement("p");
            vakantie.innerText = element.holidays
            vakantie.className = "gridrowheight"
            employediv.appendChild(vakantie);

const EW = document.createElement("p");
            EW.innerText = element.EW
            EW.className = "gridrowheight"
            employediv.appendChild(EW);


            const performancerate = document.createElement("p");
            performancerate.innerText = element.hours_not_yet_accounted
            performancerate.className = "gridrowheight"
            employediv.appendChild(performancerate);


            employediv.id = element.assignee_Id.toString() + "_" + element.year.toString() + "_" + element.Month.toString()
            
            employediv.addEventListener('click', function (e) {
                setSelectedReportdata({})
                // let newselectedreport = element.assignee_Id.toString() + "_" + element.year.toString() + "_" + element.Month.toString()

                // if (document.getElementById(sessionStorage.getItem('selectedreport')) !== null) {
                //     let replacestring = document.getElementById(sessionStorage.getItem('selectedreport')).className
                //     if (replacestring.includes("linkVarient")) {
                //         var new_str = replacestring.replace(" ActivityReportselectedRow", '');
                //         document.getElementById(sessionStorage.getItem('selectedreport')).className = new_str
                //     }
                // }
                // console.log("newselectedreport",  document.getElementById(newselectedreport))
                // //document.getElementById(newselectedreport).className += " ActivityReportselectedRow"
                
                setSelectedReportdata(element);
                
                // sessionStorage.setItem('selectedreport', newselectedreport)
                document.getElementById("activityreportdetails").style.display = "block"
                document.getElementById("coverAll").style.display = "block"
            })

            employediv.className = "tableheader"
            // const selector = document.createElement("input");
            // selector.className = "smallselector";
            // selector.id = "selector_" + element.assignee_Id.toString() + "_" + element.year.toString() + "_" + element.Month.toString()
            // selector.value = index;
            // if (sessionStorage.getItem('selectedreport') === element.assignee_Id.toString() + "_" + element.year.toString() + "_" + element.Month.toString()) {
            //     employediv.className += " ActivityReportselectedRow"
            //     //employediv.appendChild(selector);
            // } else {
                //dynamicaly add classname
                if (index % 2 === 0) {
                    employediv.className = "linkVarient1 gridActivityReportList"
                } else {
                    employediv.className = "linkVarient2 gridActivityReportList"
                }
            //}

            divlist.appendChild(employediv)
            if (sessionStorage.getItem('selectedreport') !== null && document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')) !== null) {
                document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')).focus()
                document.getElementById("selector_" + sessionStorage.getItem('selectedhotel')).disabled = true;
            }

        }
        );

    }
    const showdetails = (element) => {

        console.log("element", element)
    }
    //TODO: gethotelcleaners bevat niet de nr_wkn van de employee
    const GetHotelCleaners = async (HotelId, active) => {
        setoptionArray([])
        setselectedCleaner(null)
        setlinkedcleaners([])
        if (HotelId) {
            const res = await gethotelcleaners(HotelId, active);
            const data = await res.json();

            for (const cleaner of data.items) {
                ////console.log("cleaner = " , data.items)
                setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
            }
        } else {

            const Employees = getemployees(active);
            Employees.then((list) => {
                if (list.status === 200) {
                    for (const cleaner of list.items) {
                        ////console.log("cleaner" , list.items)
                        setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
                    }

                }
            })
        }
    }

    const GetActiveHotelCleaners = (e) => {
        setGetactiveEmployees(e.target.checked)
        GetHotelCleaners(selectedhotel, e.target.checked)
    }

    useEffect(() => {
        //////console.log(linkedcleaners)
        if (Object.keys(linkedcleaners).length > 0) {
            const options = Object.keys(linkedcleaners).map((key) => {
                const emp = linkedcleaners[key].cleaner;
                if (emp.nr_wkn)
                    return { value: key, label: `${emp.nr_wkn} - ${emp.achternaam}, ${emp.voornaam} ` };
                else
                    return { value: key, label: `${emp.achternaam}, ${emp.voornaam} ` };
            })
            setoptionArray(options)
        }
        createyearselect()
    }, [linkedcleaners]);
    //dop something after loading page
    useEffect(() => {
        GetHotelCleaners(selectedhotel, getactiveEmployee)
        // fetchData();
    }, [props.rights]);


    const getHotelEmployees = (e) => {
        setSelectedhotel(e.target.value)
        ////console.log(e.target.value, "  " ,getactiveEmployee)
        GetHotelCleaners(e.target.value, getactiveEmployee)
    }
    const selectchange = (option) => {
        setselectedCleaner(option ? option.value : null);
    }

    const startdrag = (windowname, drag, e) => {
        setWindowtodrag(windowname)
        var rect = e.target.getBoundingClientRect();
        setleft(e.clientX - rect.left)
        settop(e.clientY - rect.top)
        setDragWindow(drag)
    }
    const MouseMove = (e) => {
        if (dragwindow === true && windowtodrag !== null) {
            document.getElementById(windowtodrag).style.zIndex = 250000
            document.getElementById(windowtodrag).style.top = (e.clientY - (10 - window.pageYOffset)) + "px"
            document.getElementById(windowtodrag).style.left = (e.clientX - (left - window.pageXOffset)) + "px"
        }
    }
    const handleCancel = () => {
        document.getElementById("activityreportdetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }
    return (

        <div id="main">
            <header>
                <div id="errordiv" className='error'></div>
                <div id="coverAllmessage" className="coverall">
                    <div id="messagediv" className='message'>
                        <div id="messagetext" className="MessageText"></div><br></br>
                        <center>
                            <div className='messageBoxes'>
                                <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={clearMessage}>{t("OK")}</Button>
                            </div></center>
                    </div></div>

            </header>
            <div id="filters" className="form" >
                <label className='formtitleContentBox'>{t("filterinstellingen")}</label>
                <br></br>
                <div className="contentbox">
                    <div className="formElement">
                        <label className='labelcolor'>
                            {t("year")}:
                        </label>
                        <select id="yearselection" className='employeecombolist'>
                        </select>
                    </div>

                    <div className="formElement">
                        <label className='labelcolor'>
                            {t("month")}:
                        </label>
                        <select id="monthselection" className='employeecombolist'>
                            <option value="0">{t("pickamonth")}</option>
                            <option value="1">{t("1")}</option>
                            <option value="2">{t("2")}</option>
                            <option value="3">{t("3")}</option>
                            <option value="4">{t("4")}</option>
                            <option value="5">{t("5")}</option>
                            <option value="6">{t("6")}</option>
                            <option value="7">{t("7")}</option>
                            <option value="8">{t("8")}</option>
                            <option value="9">{t("9")}</option>
                            <option value="10">{t("10")}</option>
                            <option value="11">{t("11")}</option>
                            <option value="12">{t("12")}</option>
                        </select>
                    </div>

                    <div className="formElement gridformidentity_4">
                        <label className='labelcolor'>
                            {t("employee")}:
                        </label>

                        <Select
                            id="employeeList"
                            onChange={selectchange}
                            options={optionArray}
                            value={optionArray.find(opt => opt.value === selectedCleaner) || null}
                            placeholder={t('Kies een medewerker')}
                            isSearchable
                            className='employeecombolist'
                        />
                        <label className='labelcolor left'>
                            {t("Active")}:
                        </label>
                        <input type="checkbox" id="activeEmployee" className="checkbox" name="approved" onChange={GetActiveHotelCleaners} defaultChecked="true">
                        </input>
                    </div>

                    <div className="formElement">
                        <label className='labelcolor' />
                        <button className='buttoncontainer filterButton' type='button' id="filterbutton" onClick={() => filterlist(navigate, t)}>{t("filter")}</button>
                    </div>
                    <br></br>
                </div>
                <br></br>
                <div id="headertable" className="tableheader gridActivityReportList">
                    <p id="ID">{t('nr_wkn')} </p>
                    <p id="Fullname">{t('Fullname')}</p>
                    <p id="Month">{t('Month')}</p>
                    <p id="TimeIn">{t('Werk')} /u</p>
                    <p id="Timeout">{t('Vrij')} /d</p>
                    <p id="Ziek">{t('Ziek')} /d</p>
                    <p id="Vakantie">{t('Vakantie')}</p>
                                        <p id="EW">{t('EW')}</p>
                    <p id="hours_not_yet_accounted">{t('hours_not_yet_accounted')}</p>
                </div>
                <div id="list" className="list">
                </div>
            </div>
            <div id="coverAll" className="subscreen" onMouseMove={MouseMove}>
                <ActivityreportDetails
                    rights={props.rights}
                    t={props.translation}
                    isDisabled={true}
                    data={{ reportdata: selectedreportdata }}
                    events={{
                        handleCancel: handleCancel,
                        startdrag: startdrag,
                    }}
                />
            </div>
        </div>
    )

}

export default ActivityReport